import {ITeamStandingsData, ITeamStandingsItem, ITimeTableItemState} from '@App/types';
import HttpRequestError from '@Utils/HttpRequestError';

export type ResultListApiResponse = {
  data: ITeamStandingsData,
  eventState: ITimeTableItemState,
}

export function fetchTeamStandingsData(timeTableId: number, abortSignal: AbortSignal) {
  return fetch(`${process.env.PUBLIC_URL}/api/v1/teamstandings/${timeTableId}`, {
    signal: abortSignal,
  }).then(async (response): Promise<ResultListApiResponse> => {
    if (!response.ok) {
      const textResponse = await response.text();
      throw new HttpRequestError(response.status, 'Failed to get TeamStandings data', textResponse);
    }

    const jsonRepsonse = await response.json();
    return jsonRepsonse;
  });
}

const defaultExport = {
  fetchTeamStandingsData
};

export default defaultExport;
